import { render, staticRenderFns } from "./widget-nuxt.vue?vue&type=template&id=e347e400"
import script from "./widget-nuxt.vue?vue&type=script&lang=js"
export * from "./widget-nuxt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetNuxtWrapper: require('/data/wwwroot/xd-website/sys-builder/v3.0/bale/nuxt-www.taptap.cn/apps/baler-nuxt-pre/components/widget-nuxt-wrapper.vue').default})
